import React from 'react'
import { MapPin, Clock, Calendar, IndianRupee, Building2 } from 'lucide-react'

const JobCard = ({ data }) => {
    return (
        <div className='bg-white hover:shadow-xl hover:shadow-blue-900/5 transition-all duration-300 border border-slate-100 rounded-2xl p-6'>
            <main className='flex flex-col sm:flex-row gap-6 items-start'>
                
                {/* Logo Placeholder */}
                <div className='w-16 h-16 rounded-xl bg-blue-50 flex items-center justify-center flex-shrink-0 border border-blue-100'>
                    {data.company_inrto ? (
                        <Building2 className="text-blue-500" size={32} strokeWidth={1.5} />
                    ) : (
                        <img src={require('../../Assest/cards/jobIcon.avif')} alt="Icon" className='w-10 h-10 object-contain' loading='lazy' />
                    )}
                </div>
                
                <section className='flex-1 min-w-0 w-full'>
                    {/* Header */}
                    <div className="mb-4">
                        <p className='text-blue-600 font-bold text-sm tracking-wide uppercase mb-1 truncate' >
                            {data.company_inrto || 'Merida HR'}
                        </p>
                        <h4 className='text-xl font-black text-slate-900 truncate'>
                            {data.Title}
                        </h4>
                    </div>

                    {/* Tags */}
                    <article className='flex flex-wrap gap-2 text-sm items-center mb-5' >
                        <div className='flex items-center gap-1.5 bg-slate-50 border border-slate-200 text-slate-700 px-3 py-1.5 rounded-md flex-shrink-0' >
                            <MapPin size={14} className="text-slate-400" />
                            <span className='truncate font-medium'>{data.job_location}</span>
                        </div>
                        <div className='flex items-center gap-1.5 bg-blue-50 border border-blue-100 text-blue-700 px-3 py-1.5 rounded-md flex-shrink-0' >
                            <Clock size={14} className="text-blue-400" />
                            <span className='truncate font-medium'>{data.job_type}</span>
                        </div>
                        
                        {(data.min_salary || data.max_salary) && (
                            <div className='flex items-center gap-1.5 bg-green-50 border border-green-100 text-green-700 px-3 py-1.5 rounded-md flex-shrink-0' >
                                <IndianRupee size={14} className="text-green-500" />
                                <span className='truncate font-medium'>
                                    {data.min_salary && (data.min_salary) + (data.salary_type || '')}
                                    {data.min_salary && data.max_salary && " - "}
                                    {data.max_salary && (data.max_salary) + (data.salary_type || '')}
                                </span>
                            </div>
                        )}
                        
                        <div className='flex items-center gap-1.5 bg-purple-50 border border-purple-100 text-purple-700 px-3 py-1.5 rounded-md flex-shrink-0' >
                            <Calendar size={14} className="text-purple-400" />
                            <span className='truncate font-medium'>
                                {data.min_exp && (data.min_exp) + " Yrs"}
                                {data.min_exp && data.Experience && " - "}
                                {data.Experience && (data.Experience) + " Yrs"}
                            </span>
                        </div>
                    </article>

                    {/* Description */}
                    <div
                        className='text-slate-600 text-[15px] leading-relaxed line-clamp-2 overflow-hidden break-words job-description-content rich-text-content'
                        style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
                        dangerouslySetInnerHTML={{ __html: data.Job_Discription }}
                    />
                </section>
                
                {/* Action button area for larger screens */}
                <div className="hidden sm:flex self-center ml-4">
                    <button className="bg-slate-900 text-white font-bold py-2 px-6 rounded-full hover:bg-blue-600 transition-colors whitespace-nowrap">
                        View Details
                    </button>
                </div>
            </main>
        </div>
    )
}

export default JobCard